export default __webpack_public_path__ + "static/6916-3aaf6e5e4aa255f87975d11eefe3c316.jpg";